const { transformEnumToObject } = require('@/tools');
const {
  CHANNEL_INTERFACE_TYPE,
  CHANNEL_INTERFACE_TEXT,
  ADVERTISER_SOURCE_TYPE,
  ADVERTISER_SOURCE_TEXT,
} = require('@/enums');

module.exports = (s) => {
  return {
    advertiser: {
      label: '媒体平台',
      value: '',
      format: () => {
        const { advertiser: { value: advertiser }} = s.drawer_config.props.descriptionsConfig;
        const channel_interface_map = transformEnumToObject(CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT);
        return channel_interface_map[advertiser];
      },
    },
    advertiser_id: {
      label: '广告主账户',
      value: '',
    },
    name: {
      label: '模板名称',
      value: '',
    },
    advertiser_source_type: {
      label: '操作目标',
      value: '',
      format: () => {
        const { advertiser_source_type: { value: advertiser_source_type }} = s.drawer_config.props.descriptionsConfig;
        const advertiser_source_type_map = transformEnumToObject(ADVERTISER_SOURCE_TYPE, ADVERTISER_SOURCE_TEXT);
        return advertiser_source_type_map[advertiser_source_type];
      },
    },
    status: {
      label: '提交状态',
      value: '',
      format: () => {
        const { status: { value: status }} = s.drawer_config.props.descriptionsConfig;
        const status_map = {
          1: '提交中',
          2: '提交完成',
          6: '重试中',
        };
        return status_map[status];
      },
    },
    result: {
      label: '提交结果',
      value: '',
      renderHtml: () => {
        const { status: { value: status }, result: { value: result }} = s.drawer_config.props.descriptionsConfig;
        const { success_num, fail_num } = result;
        const html = `
          <span class="color-green">成功：${success_num}</span>
          <span class="color-red ml-10">失败：${fail_num}</span>
        `;
        return status === 1 ? '-' : html;
      },
    },
  };
};
